const initialState = {
  loading: false
};

export function dealerInfo(state = initialState, action) {

  switch (action.type) {
    case 'SAVE.DEALER_INFO.SUCCESS':
    case 'FETCH.DEALER_INFO.SUCCESS':
      return {
        ...state,
        ...action.dealerInfo.body,

      };
    default:
      return state
  }
}
